import { ReactNode } from "react";

/**
 * CSS-only page transition. Replaces framer-motion to keep it out of the
 * initial entry chunk and reduce unused JS on first paint.
 */
export function PageTransition({ children }: { children: ReactNode }) {
  return <div className="animate-page-fade">{children}</div>;
}
